/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Duplicate_ListingInputs */

const en_duplicate_listing = /** @type {(inputs: Duplicate_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duplicate Listing`)
};

const es_duplicate_listing = /** @type {(inputs: Duplicate_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duplicar anuncio`)
};

const fr_duplicate_listing = /** @type {(inputs: Duplicate_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dupliquer l'annonce`)
};

const de_duplicate_listing = /** @type {(inputs: Duplicate_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserat duplizieren`)
};

const ja_duplicate_listing = /** @type {(inputs: Duplicate_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出品を複製`)
};

const zh_duplicate_listing = /** @type {(inputs: Duplicate_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复制商品`)
};

const ar_duplicate_listing = /** @type {(inputs: Duplicate_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تكرار الإعلان`)
};

const id_duplicate_listing = /** @type {(inputs: Duplicate_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duplikat Listing`)
};

const it_duplicate_listing = /** @type {(inputs: Duplicate_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duplica Annuncio`)
};

const ru_duplicate_listing = /** @type {(inputs: Duplicate_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дублировать объявление`)
};

const pt_duplicate_listing = /** @type {(inputs: Duplicate_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duplicar Anúncio`)
};

const ko_duplicate_listing = /** @type {(inputs: Duplicate_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`상품 복제`)
};

/**
* | output |
* | --- |
* | "Duplicate Listing" |
*
* @param {Duplicate_ListingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const duplicate_listing = /** @type {((inputs?: Duplicate_ListingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Duplicate_ListingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_duplicate_listing(inputs)
	if (locale === "es") return es_duplicate_listing(inputs)
	if (locale === "fr") return fr_duplicate_listing(inputs)
	if (locale === "de") return de_duplicate_listing(inputs)
	if (locale === "ja") return ja_duplicate_listing(inputs)
	if (locale === "zh") return zh_duplicate_listing(inputs)
	if (locale === "ar") return ar_duplicate_listing(inputs)
	if (locale === "id") return id_duplicate_listing(inputs)
	if (locale === "it") return it_duplicate_listing(inputs)
	if (locale === "ru") return ru_duplicate_listing(inputs)
	if (locale === "pt") return pt_duplicate_listing(inputs)
	return ko_duplicate_listing(inputs)
});